import React from "react";
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { Paragraph } from "../theme/typography";

const CardContainer = styled(Link)`
    background: 
			linear-gradient(0deg, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0) 50%),
			url(${(props) => props.background}) no-repeat center/cover;
    background-color: ${(props) => props.theme.colors.purple4};
    border-radius: 0.5rem;
	box-sizing: border-box;
    color: ${(props) => props.theme.colors.neutral10};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
	max-height: 50vh;
    overflow: hidden;
    padding: 1rem;
    position: relative;
    text-decoration: none;

    &:hover {
        background-color: ${(props) => props.theme.colors.purple3};
		background: 
				linear-gradient(0deg, rgba(114, 56, 153, 0.4) 0%, rgba(114, 56, 153, 0.2) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.8) 10%, rgba(0, 0, 0, 0.1) 60%),
				url(${(props) => props.background}) no-repeat center/cover;
    }

    &::before {
        content: "";
        display: block;
        padding-top: 56.25%; /* 16:9 aspect ratio */
    }
`;

const CardContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 1rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
		padding: 2rem;
	}
`;

export const CardTitle = styled.h3`
    ${(props) => props.theme.typography.headingM};
    margin: 0 0 0.5rem;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
		${(props) => props.theme.typography.headingL};
		margin-bottom: 0.75rem;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.fourth}) {
		${(props) => props.theme.typography.headingXL};
		margin-bottom: 1rem;
	}
`;


export const CardSubtitle = styled.h4`
    ${(props) => props.theme.typography.heading2XS};
	color: ${(props) => props.theme.colors.yellow6};
    margin: 0 0 0.5rem;
	text-transform: uppercase;

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
		${(props) => props.theme.typography.headingXS};
		margin-bottom: 0.75rem;
	}

	@media only screen and (min-width: ${(props) => props.theme.breakpoints.fourth}) {
		${(props) => props.theme.typography.headingXS};
		margin-bottom: 1rem;
	}
`;

export const CardDescription = styled(Paragraph)`
    margin: 0;
	text-wrap: balance;
`;

export const Card = ({ className, to, background, title, subtitle, description }) => (
    <CardContainer className={className} to={to} background={background}>
        <CardContent>
            {title && <CardTitle>{title}</CardTitle>}
            {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
            {description && <CardDescription>{description}</CardDescription>}
        </CardContent>
    </CardContainer>
);